export default "__VITE_ASSET__CkE0suz6__"